import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useShowMessage } from '../providers'
import {
  getProjects,
  GetProjectsResponseData
} from '@pepper/utils/src/api/projects/getProjects'

export const usePaginatedProjects = (
  queryParams: Partial<ProjectQueryParams>,
  config?: UseQueryOptions<GetProjectsResponseData, Error>
): {
  projects: Project[]
  totalProjects: number
  currentPage: number
  isProjectsLoading: boolean
  isProjectsFetching: boolean
  errorProjects: Error | null
  refetchProjects: () => void
} => {
  const showMessage = useShowMessage()

  const { data, isLoading, isFetching, error, refetch } = useQuery<
    GetProjectsResponseData,
    Error
  >({
    queryKey: ['/projects', queryParams],
    queryFn: async () => {
      const response = await getProjects({
        query_params: queryParams,
        page: queryParams.current_page,
        page_size: queryParams.page_size,
        paginationEnabled: queryParams.pagination_enabled
      })

      if (response.status === 'error') throw new Error(response.error)

      return response.data
    },
    onError: _error => showMessage({ type: 'error', message: _error.message }),
    ...config
  })

  return {
    projects: data ? data.records : [],
    totalProjects: data ? data.total_records : 0,
    currentPage: queryParams.current_page || 0,
    isProjectsLoading: isLoading,
    isProjectsFetching: isFetching,
    errorProjects: error,
    refetchProjects: refetch
  }
}
